import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState, useMemo } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  CircularProgress,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  FormHelperText,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { post } from "../../../../src/services/http";
import { ContextSession } from "../../../services/ContextSession";
import FilterListIcon from "@mui/icons-material/FilterList";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import CryptoJS from "crypto-js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HandymanIcon from "@mui/icons-material/Handyman";
import DeleteIcon from "@mui/icons-material/Delete";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: "none",
    borderLeft: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: "#C1C1C1",
  },
}));

function ListaSolConstanciasCallCenter() {
  let sessi = useContext(ContextSession);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loanType, setLoanType] = useState("");
  const [statusFilter, setStatusFilter] = useState("1");
  const [searchDNI, setSearchDNI] = useState("");
  const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);

  const [estadoFilter, setEstadoFilter] = useState("");

  const estadosConstancia = {
    1: "PENDIENTE DE PAGO",
    2: "PAGADA",
    3: "CANCELADA",
    4: "EMITIDA",
    5: "ANULADA",
    6: "REVISANDO",
  };

  const obtenerEstadoConstancia = (row) => {
    if (row.subsanando === true) return "SUBSANANDO";
    if (
      row.recepcionOficina === false &&
      row.oficinaEntregaParticipante === false &&
      row.enviadaOficina === true
    ) {
      return "PENDIENTE DE RECIBIR";
    }
    if (
      row.recepcionOficina === true &&
      row.oficinaEntregaParticipante === false
    ) {
      return "LISTA PARA ENTREGA";
    }

    return estadosConstancia[row.fk_id_estado] || "DESCONOCIDO";
  };

  const prioridadEstadoConstancia = {
    "LISTA PARA ENTREGA": 1,
    "PENDIENTE DE RECIBIR": 2,
    PAGADA: 3,
    "PENDIENTE DE PAGO": 4,
    EMITIDA: 5,
    REVISANDO: 6,
    SUBSANANDO: 7,
    ANULADA: 98,
    CANCELADA: 99,
  };

  const opcionesFiltroEstado = [
    "PENDIENTE DE PAGO",
    "PAGADA",
    "LISTA PARA ENTREGA",
    "PENDIENTE DE RECIBIR",
    "CANCELADA",
    "EMITIDA",
    "ANULADA",
    "REVISANDO",
    "SUBSANANDO",
  ];

  const tiposConstancia = {
    1: "HISTORIAL DE COTIZACIONES",
    2: "RAZONADA",
    3: "SALDOS PROYECTADOS",
    4: "NO TENER PRÉSTAMO ACTIVO",
    5: "TRÁMITE EMBAJADA",
  };

  // CORRECCIÓN: Cambiar el nombre para evitar conflicto
  const filteredData = useMemo(() => {
    if (!rows || rows.length === 0) return [];

    return rows.filter((row) => {
      // Filtro por término de búsqueda
      const matchesSearch =
        searchTerm === "" ||
        (row.DNI && row.DNI.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.NombreCompleto &&
          row.NombreCompleto.toLowerCase().includes(
            searchTerm.toLowerCase()
          )) ||
        (row.numero_recibo &&
          row.numero_recibo.toLowerCase().includes(searchTerm.toLowerCase()));

      const estadoVisible = obtenerEstadoConstancia(row);
      const matchesEstado =
        estadoFilter === "" || estadoVisible === estadoFilter;

      return matchesSearch && matchesEstado;
    });
  }, [rows, searchTerm, estadoFilter]);

  const sortedFilteredData = useMemo(() => {
    return [...filteredData].sort((a, b) => {
      const prioridadA =
        prioridadEstadoConstancia[obtenerEstadoConstancia(a)] ?? 50;
      const prioridadB =
        prioridadEstadoConstancia[obtenerEstadoConstancia(b)] ?? 50;

      if (prioridadA !== prioridadB) {
        return prioridadA - prioridadB;
      }

      return new Date(b.fecha_registro || 0) - new Date(a.fecha_registro || 0);
    });
  }, [filteredData]);

  //const dominio = "http://127.0.0.1:8000";
  const dominio = "https://be.injupemp.gob.hn:8443";

  // Estados para dialog y fila seleccionada
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [patchLoading, setPatchLoading] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openDialogSubsanar, setOpenDialogSubsanar] = useState(false);
  const [openSuccessDialogSubsanar, setOpenSuccessDialogSubsanar] =
    useState(false);
  const [observacion, setObservacion] = useState("");
  const [camposSeleccionados, setCamposSeleccionados] = useState({
    copiaDNI: false,
    copiaConstancia: false,
  });
  const [errorObservacion, setErrorObservacion] = useState(false);
  const [errorDocumentos, setErrorDocumentos] = useState(false);
  const [formValido, setFormValido] = useState(false);

  const [openDialogRechazar, setOpenDialogRechazar] = useState(false);
  const [openSuccessDialogRechazar, setOpenSuccessDialogRechazar] =
    useState(false);

  useEffect(() => {
    const documentosValidos =
      camposSeleccionados.copiaDNI || camposSeleccionados.copiaConstancia;
    const observacionValida = observacion.trim().length > 0;

    setErrorDocumentos(!documentosValidos);
    setErrorObservacion(!observacionValida);
    setFormValido(documentosValidos && observacionValida);
  }, [camposSeleccionados, observacion]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8"; // Agrega tu secret key aquí
      const queryString = `IdTipo=${statusFilter}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );

      const response = await fetch(
        `${dominio}/api/ConstanciaPag/Tipo/?IdTipo=${statusFilter}`,
        {
          method: "GET",
          headers: {
            "X-Signature": signature,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Error al obtener los datos");
      const data = await response.json();
      setRows(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setRows([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [statusFilter]);

  const handleClick = (id) => {
    sessi.setVariable("IDsolConstancia", id);
    navigate("/PortalDelParticipante/VerSolConstanciaEntrega");
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // CORRECCIÓN: Agregar buscador y filtro de estado al Box existente
  const handleOpenDialog = (row) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  // ... (resto de las funciones handleAccept, handleOpenDialogSubsanar, etc. se mantienen igual)

  const handleAccept = async () => {
    if (!selectedRow) return;
    setPatchLoading(true);
    try {
      const secretKey = ""; // Agrega tu secret key aquí
      const idSolicitud = selectedRow.id_solicitud_constancia;
      const idUser = sessi.sessionData.id;
      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );

      const url = `${dominio}/api/ConstanciaPag/ConstanciaSG/Aprobar/?IdSolicitud=${idSolicitud}&IdUserSG=${idUser}`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Error al aprobar la solicitud");
      setOpenDialog(false);
      setOpenSuccessDialog(true);
    } catch (error) {
      alert("Ocurrió un error al aprobar la solicitud.");
    }
    setPatchLoading(false);
  };

  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
    fetchData();
  };

  // ... (mantén el resto de las funciones igual)

  return (
    <div className="container" style={{ marginTop: 10 }}>
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 10,
          }}
        >
          <h2>
            <b>Lista de Solicitudes de Constancias en INJUPEMP Conectados</b>
          </h2>
        </div>

        {/* CORRECCIÓN: Agregar buscador y filtros aquí */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            mb: 2,
            mt: 1,
            justifyContent: "center",
          }}
        >
          <FormControl size="small" sx={{ minWidth: 170 }}>
            <FormHelperText>Filtrar por Tipo</FormHelperText>
            <Select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setPage(0);
              }}
              displayEmpty
              fullWidth
            >
              <MenuItem value="1">Historial de Cotizaciones</MenuItem>
              <MenuItem value="2">Razonadas</MenuItem>
            </Select>
          </FormControl>

          {/* BUSCADOR GENERAL */}
          <FormControl size="small" sx={{ minWidth: 250 }}>
            <FormHelperText>Buscar</FormHelperText>
            <TextField
              size="small"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(0);
              }}
              placeholder="DNI, Solicitante o N° Recibo"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>

          {/* FILTRO POR ESTADO */}
          <FormControl size="small" sx={{ minWidth: 170 }}>
            <FormHelperText>Filtrar Constancias:</FormHelperText>
            <Select
              value={estadoFilter}
              onChange={(e) => {
                setEstadoFilter(e.target.value);
                setPage(0);
              }}
              displayEmpty
              fullWidth
            >
              <MenuItem value="">Todos los estados</MenuItem>
              {opcionesFiltroEstado.map((estado) => (
                <MenuItem key={estado} value={estado}>
                  {estado}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <div className="row" style={{ marginTop: "20px" }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>#</StyledTableCell>
                  <StyledTableCell>DNI Solicitante</StyledTableCell>
                  <StyledTableCell>Solicitante</StyledTableCell>
                  <StyledTableCell>Télefono</StyledTableCell>
                  <StyledTableCell>Nº Recibo</StyledTableCell>
                  <StyledTableCell>Tipo Constancia</StyledTableCell>
                  <StyledTableCell>Monto</StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Fecha Registro
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Estado
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Ubicación Actual
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Detalle Solicitud
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      <CircularProgress size={24} />
                    </StyledTableCell>
                  </StyledTableRow>
                ) : sortedFilteredData && sortedFilteredData.length > 0 ? (
                  sortedFilteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => (
                      <StyledTableRow key={row.id_solicitud_constancia}>
                        <StyledTableCell>
                          {page * rowsPerPage + idx + 1}
                        </StyledTableCell>
                        <StyledTableCell>{row.DNI}</StyledTableCell>
                        <StyledTableCell>{row.NombreCompleto}</StyledTableCell>
                        <StyledTableCell>{row.telefono}</StyledTableCell>
                        <StyledTableCell>{row.numero_recibo}</StyledTableCell>
                        <StyledTableCell>
                          {tiposConstancia[row.fk_id_constancia] ||
                            "DESCONOCIDO"}
                        </StyledTableCell>
                        <StyledTableCell>L.{row.monto}</StyledTableCell>
                        <StyledTableCell>
                          {row.fecha_registro
                            ? row.fecha_registro.split("T")[0] +
                              " " +
                              row.fecha_registro.split("T")[1].substring(0, 8)
                            : "-"}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: "center" }}>
                          <span
                            style={{
                              backgroundColor:
                                row.subsanando === true
                                  ? "#ff9800ff"
                                  : row.recepcionOficina === true &&
                                    row.oficinaEntregaParticipante === false
                                  ? "#00c3ffff"
                                  : row.fk_id_estado === 6
                                  ? "#a37e0dd5"
                                  : row.fk_id_estado === 1
                                  ? "#22c1e9d3"
                                  : row.fk_id_estado === 2
                                  ? "#46a091ff"
                                  : row.fk_id_estado === 3
                                  ? "#ff0000d5"
                                  : row.fk_id_estado === 4
                                  ? "#21964eff"
                                  : row.fk_id_estado === 5
                                  ? "#ff3d3dd5"
                                  : "#b3b325ff",
                              borderRadius: 10,
                              color:
                                row.subsanando === true ? "white" : "black",
                              padding: 10,
                              width: "150px",
                              display: "inline-block",
                            }}
                          >
                            {obtenerEstadoConstancia(row)}
                          </span>
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: "center" }}>
                          <span
                            style={{
                              backgroundColor:
                                row.subsanando === true
                                  ? "#ff9800ff"
                                  : row.fk_id_estado === 6
                                  ? "#a37e0dd5"
                                  : row.fk_id_estado === 1
                                  ? "#22c1e9d3"
                                  : row.fk_id_estado === 2
                                  ? "#46a091ff"
                                  : row.fk_id_estado === 3
                                  ? "#ff0000d5"
                                  : row.fk_id_estado === 4
                                  ? "#21964eff"
                                  : row.fk_id_estado === 5
                                  ? "#ff3d3dd5"
                                  : "#b3b325ff",
                              borderRadius: 10,
                              color:
                                row.subsanando === true ? "white" : "black",
                              padding: 10,
                              width: "150px",
                              display: "inline-block",
                            }}
                          >
                            {row.subsanando === true
                              ? "Participante"
                              : row.fk_id_estado === 6
                              ? "Secretaría General"
                              : row.fk_id_estado === 1
                              ? "Participante"
                              : row.fk_id_estado === 2 &&
                                row.enviadaOficina === false &&
                                (row.fk_id_constancia === 1 ||
                                  row.fk_id_constancia === 2)
                              ? "OPERACIONES"
                              : row.fk_id_estado === 2 &&
                                row.enviadaOficina === true &&
                                row.fk_id_constancia === 1 &&
                                row.FKIdOficina === 1
                              ? "Oficina de Tegucigalpa"
                              : row.fk_id_estado === 2 &&
                                row.enviadaOficina === true &&
                                row.fk_id_constancia === 1 &&
                                row.FKIdOficina === 2
                              ? "Oficina de San Pedro Sula"
                              : row.fk_id_estado === 2 &&
                                row.enviadaOficina === true &&
                                row.fk_id_constancia === 1 &&
                                row.FKIdOficina === 3
                              ? "Oficina de La Ceiba"
                              : row.fk_id_estado === 2 &&
                                row.enviadaOficina === true &&
                                row.fk_id_constancia === 1 &&
                                row.FKIdOficina === 4
                              ? "Oficina de Choluteca"
                              : row.fk_id_estado === 2 &&
                                row.enviadaOficina === true &&
                                row.fk_id_constancia === 1 &&
                                row.FKIdOficina === 5
                              ? "Oficina de Santa Rosa de Copán"
                              : row.fk_id_estado === 2 &&
                                row.enviadaOficina === true &&
                                row.fk_id_constancia === 1 &&
                                row.FKIdOficina === 6
                              ? "Oficina de Santa Bárbara"
                              : row.fk_id_estado === 2 &&
                                row.enviadaOficina === true &&
                                row.fk_id_constancia === 1 &&
                                row.FKIdOficina === 7
                              ? "Oficina de Juticalpa"
                              : row.fk_id_estado === 4
                              ? "Participante"
                              : estadosConstancia[row.fk_id_estado] ||
                                "DESCONOCIDO"}
                          </span>
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: "center" }}>
                          <Tooltip
                            title="Ver Solicitud"
                            arrow
                            placement="left-start"
                          >
                            <IconButton
                              onClick={() =>
                                handleClick(row.id_solicitud_constancia)
                              }
                            >
                              <VisibilityIcon
                                sx={{ color: "green", fontSize: 30 }}
                              />
                            </IconButton>
                          </Tooltip>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      No hay datos.
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={sortedFilteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            labelRowsPerPage={"Filas por página"}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>

        {/* ... (mantén el resto de los diálogos igual) */}
      </>
    </div>
  );
}

export default ListaSolConstanciasCallCenter;
